
<template>
  <div class="tableHolder" >
    <!--    <a-spin tip="Loading..." :spinning="loading">-->
    <a-table
        ref="table"

        table-layout="auto"
        size="middle"
        :columns="customGameTitleList"
        :data-source="tableData"
        :row-key="(record, index) => index"
        :pagination="false"
        :bordered="true"
        :scroll="{ x: 1500, y: '75vh' }"
    >
      <!--      <div slot="noTitle" style="font-weight: bold;font-size: 16px;width:100%;text-align: center;">-->
      <!--        {{"编号"}}-->
      <!--      </div>-->
      <!--      <div slot="no" slot-scope="_, item">-->
      <!--        <div :key="0" style="text-align: center">-->
      <!--          {{item.player_id}}-->
      <!--        </div>-->
      <!--      </div>-->
      <div slot="nameTitle" style="font-weight: bold;font-size: 16px;text-align: center;">
        {{"姓名"}}
      </div>
      <div slot="name" slot-scope="_, item">
        <div :key="1" style="text-align: center" >
          {{item.player_name}}
        </div>
      </div>
      <div
          v-for="(column,index) in gameList"

          style="cursor: pointer"
          :slot="`gameTitle-${index}`"
          :key="index">

        <div  style="color: #fff;font-size: 16px;text-align: center;width:100%;font-weight: bold">{{`${gameList[index].match_name}`}}</div>
        <div  style="color: #fff;width:100%">地点：{{gameList[index].location}}</div>
        <div  style="color: #fff;width:100%">时间：{{getDateName(gameList[index].start_date,gameList[index].end_date)}}</div>
      </div>

      <div v-for="(column, index) in customGameTitleList.slice(1,gameList.length+1)"
           :slot="column.dataIndex"
           :key="index"
           slot-scope="_, item"
      >
        <div >
          <!--          <UnitSample  :msg="unit" :value="item" :colIdx="index" />-->
          <TypeSelect :values="{
                playerId: item.player_id,
                gender:item.gender,
                competitionId:item.comp[index].match_id ,
                single: item.comp[index].single,
                double: item.comp[index].double,
                team: item.comp[index].team,
                mixed: item.comp[index].mixed,
                mixedPartnerName: item.comp[index].mixed_partner_name?item.comp[index].mixed_partner_name:'',
                doublePartnerName: item.comp[index].double_partner_name?item.comp[index].double_partner_name:'',
                mixedPartner: item.comp[index].mixed_partner_id?item.comp[index].mixed_partner_id:'',
                doublePartner: item.comp[index].double_partner_id?item.comp[index].double_partner_id:'',
              }" :bfvalue="item" @changeTypeValue="(data)=>{
                // if(!loading)loading=true;
                changeTypeValue(data,item.key,index)}"/>
          <!-- <TypeSelect :values="example"/> -->
        </div>
      </div>

      <div v-for="(i) in [1,2,3,4]"
           :slot="`sum${i}Title`"
           :key="`sum${i}Title`"
           style="color: #ffffff;font-weight: bold;font-size: 16px;width:100%;text-align: center;"
      >
        {{sumTitleName[judgeGender[currentTeam?currentTeam:'mixed']][i-1]}}
      </div>
      <div v-for="(i) in [1,2,3,4]"
           :slot="`sum${i}`"
           :key="i"
           slot-scope="_, item">
        <div
            :key="`sum${i}`"
        >
          <StatisticBars slot="action" :values="{
                  playerId: item.player_id,
                  gender:item.gender,
                  max:maxNum,
                  ...item.sum[i-1]
              }"/>
        </div>
      </div>
    </a-table>
    <!--    </a-spin>-->
    <HybridSelectFilterOption
        :isVisible="mixedSelect.visible"
        :selectInfo="mixedSelect"
        @changeMixedPartner="changeMixedPartner" />
    <HybridSelectFilterOption
        :isVisible="doubleSelect.visible"
        :selectInfo="doubleSelect"
        @changeMixedPartner="changeDoublePartner" />
  </div>

</template>
<script>
import {defineComponent} from 'vue';
import UnitSample from "@/components/table/UnitSample";
import TypeSelect from "@/components/table/TypeSelect.vue";
import StatisticBars from "@/components/table/StatisticBars.vue";
import HybridSelectFilterOption from "@/components/table/HybridSelectModel.vue"
import {getPlayerPartner,  updatePlayerParticipationInOneMatch} from "@/api";
import {message} from "ant-design-vue";

const color_custom=['#0072be','#9364c2','#00a5af','#bf936b']
const cellPadding = 0;
const headerPadding = 4;
export default defineComponent({
  components: {
    UnitSample,
    TypeSelect,
    StatisticBars,
    HybridSelectFilterOption,
  },
  props: {
    "values": {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      pagination:{
        defaultPageSize:12,
        defaultCurrent:1,
        current:1,
        // onChange:(page)=>{console.log("page",page)},
        onChange:(pageNum) => {if(pageNum !== this.currentPage) {this.currentPage=pageNum;this.pagination.current = pageNum}},
        style:{width:'100%',margin:0},
        showTotal: total => `共 ${total} 条数据`,
        showSizeChanger:true,
        pageSizeOptions: ['12', '24', '36', '100'],
        onShowSizeChange:(current, pageSize)=>this.pageSize = pageSize
      },
      currentPage:1,
      tableData:this.values.tableData,
      maxNum:this.values.maxQ,
      gameList:this.values.competitions,
      customGameTitleList:[],
      currentTeam:this.values.currentTeam,
      judgeGender:{
        "men":0,"women":1,"youth_men":0,"youth_women":1,"mixed":2,"youth_mixed":2
      },
      playerList: this.values.playerList,
      tableHolderClass:'tableHolder',
      sumTitleName:[["男单合计","男双合计","男团合计","混双合计"],["女单合计","女双合计","女团合计","混双合计"],["单打合计","双打合计","团体合计","混双合计"]],
      // loading:false,
      mixedSelect: {
        idx:0,
        playerId: 0,
        competitionId: 0,
        playerList: [],
        visible: false,
      },
      doubleSelect: {
        idx:0,
        playerId: 0,
        competitionId: 0,
        playerList: [],
        visible: false,
      },
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    values: { // 对对象进行深度监听
      handler(value) {
        if(value) {
          this.tableData=value.tableData
          this.gameList=value.competitions
          this.playerList= value.playerList
          this.currentTeam = value.currentTeam
          this.pagination.current = 1
          // this.maxNum = value.maxQ
          this.maxNum = this.maxNum > 0?this.maxNum : (value.maxQ<0?0:value.maxQ )
          // console.log("values",value)
          this.setTitleByMatchList()
        }
      },
      immediate: true,
      deep: true,
    }
  },
  methods:{
    init(){
      const slider = document.querySelector("thead.ant-table-thead tr");
      const body = document.querySelector(".ant-table-scroll .ant-table-body");
      let isDown = false;
      let startX;
      let scrollLeft;
      if(slider){
        slider.addEventListener("mousedown", (e) => {
          isDown = true;
          slider.classList.add("active");
          startX = e.pageX - body.offsetLeft;
          scrollLeft = body.scrollLeft;
        });
        // slider.addEventListener("mouseleave", () => {
        //   isDown = false;
        //   slider.classList.remove("active");
        // });
        slider.addEventListener("mouseup", () => {
          isDown = false;
          slider.classList.remove("active");
        });
        body.addEventListener("mouseup", () => {
          isDown = false;
          slider.classList.remove("active");
        });
        slider.addEventListener("mousemove", (e) => {
          // console.log("es",e,isDown)
          if (!isDown) return;
          e.preventDefault();
          const x = e.pageX - body.offsetLeft;
          const walk = (x - startX); // * 3 when need scroll-fast
          body.scrollLeft = scrollLeft - walk;
        });
        body.addEventListener("mousemove", (e) => {
          // console.log("ev",e,isDown)
          if (!isDown) return;

          e.preventDefault();
          const x = e.pageX - body.offsetLeft;
          const walk = (x - startX); // * 3 when need scroll-fast
          body.scrollLeft = scrollLeft - walk;
        });
      }
      // this.maxNum = -1
    },
    setTitleByMatchList(){
      let customGameTitleList =[
        // {
        //   dataIndex: 'no',
        //   key: 'no',
        //   width: 80,
        //   customCell:(record,rowindex)=>{return {style:{
        //     padding: 0,
        //     borderColor:'#fff',fontWeight:'bold',fontSize:'18px',backgroundColor:rowindex%2===0?'#ecf6ff':'#d4e3ef'}}},
        //   customHeaderCell:()=>{return {style:{
        //     padding: 4,
        //     backgroundColor:'#00375b',color:'#ffffff'}}},
        //   scopedSlots: { customRender: 'no' },
        //   fixed:'left',
        //   slots: {
        //     title: 'noTitle',
        //   },
        // },
        {
          dataIndex: 'name',
          key: 'name',
          width: 80,
          customCell:(record,rowindex)=>{return {style:{
              borderColor:'#fff',color:'#000',
              padding:cellPadding,
              fontWeight:'bold',fontSize:'18px',backgroundColor:rowindex%2===0?'#ecf6ff':'#d4e3ef'}}},
          customHeaderCell:()=>{return {style:{
              padding: headerPadding,
              backgroundColor:'#00375b',color:'#ffffff'}}},
          scopedSlots: { customRender: 'name' },
          fixed:'left',
          slots: {
            title: 'nameTitle',
          },
        }
      ];
      customGameTitleList=customGameTitleList.concat(
          this.gameList.map((item,idx) => {
            return {
              dataIndex: `game-${item.match_id}`,
              key: `game-${item.match_id}`,
              width: 201,
              customCell:(record,rowindex)=>{return {style:{
                  borderColor:'#fff',backgroundColor:rowindex%2===0?'#ecf6ff':'#d4e3ef',cursor:'pointer',
                  fontWeight:'bold',
                  padding:cellPadding,
                  textAlign:'center'
                }}},
              customHeaderCell:()=>{return {style:{
                  backgroundColor:'#00375b',color:'#ffffff',
                  padding: headerPadding}}},
              scopedSlots: { customRender: `game-${item.match_id}` },
              slots: {
                title: `gameTitle-${idx}`,
              },
            }
          }) ).concat([1,2,3,4].map(
          r=>{return {
            dataIndex: `sum${r}`,
            key: `sum${r}`,
            width: 89,
            customCell:(record,rowindex)=>{return {style:{
                padding:cellPadding,
                borderColor:'#fff',backgroundColor:rowindex%2===0?'#ecf6ff':'#d4e3ef'}}},
            customHeaderCell:()=>{return {style:{
                padding: headerPadding,
                backgroundColor:color_custom[r-1]}}},
            scopedSlots: { customRender: `sum${r}` },
            fixed:'right',
            slots: {
              title: `sum${r}Title`,
            },
          }}))
      this.customGameTitleList = customGameTitleList
    },
    changeTypeValue(data,playerIdx,index) {
      // console.log(playerIdx,this.tableData)
      // 设置对应的成员、比赛的数据，这里以this.example举例
      let cellData = this.tableData[playerIdx].comp[index];
      let partner_id = ''
      let shouldPostHere = true
      if(!['mixed', 'double'].includes(data.type)) {
        cellData[data.type] = data.value

      } else if(data.type==='mixed' && data.value === true) {
        // 处理要传给Mixed Select的信息并且开启Model
        // if(!this.loading)this.loading = true
        this.$store.commit('setLoading',true)
        this.getPartnerList(data.playerId,'mixed').then(
            (plist)=>{
              this.mixedSelect.playerList=plist
              this.mixedSelect.playerId = data.playerId
              this.mixedSelect.competitionId = data.competitionId
              this.mixedSelect.visible = true
              this.mixedSelect.idx = playerIdx
            }
        )
        shouldPostHere = false
      } else if(data.type==='mixed' &&data.value === false){
        this.mixedSelect.playerId = data.playerId
        this.mixedSelect.competitionId = data.competitionId
        this.mixedSelect.idx = playerIdx
        cellData.mixed_partner_id = ''
        partner_id = ''
        cellData.mixed = false
        this.mixedSelect.visible = false
      }else if(data.type==='double' && data.value === true) {
        // 处理要传给Mixed Select的信息并且开启Model
        // this.playerList = ...
        // if(!this.loading)this.loading = true
        this.$store.commit('setLoading',true)
        this.getPartnerList(data.playerId,'double').then(
            (plist)=>{
              this.doubleSelect.playerList = plist
              this.doubleSelect.playerId = data.playerId
              this.doubleSelect.competitionId = data.competitionId
              this.doubleSelect.visible = true
              this.doubleSelect.idx = playerIdx
            }
        )
        shouldPostHere = false
      } else if(data.type==='double' &&data.value === false){
        this.doubleSelect.playerId = data.playerId
        this.doubleSelect.competitionId = data.competitionId
        this.doubleSelect.idx = playerIdx
        cellData.double_partner_id = ''
        partner_id = ''
        cellData.double = false
        this.doubleSelect.visible = false
      }
      if(shouldPostHere){
        // if(!this.loading)this.loading = true
        this.$store.commit('setLoading',true)
        this.updatePlayerParticipation(data.playerId,
            cellData.match_id,  data.type,
            data.value, partner_id,playerIdx
        )
      }
    },
    async getPartnerList(player_id,type){
      const response = await getPlayerPartner(player_id,type)
      if(response.status === 200){
        // console.log("p list",response.data)
        return response.data.players
      }else{
        message.error('net error')
        return []
      }
    },
    async updatePlayerParticipation(playerId,match_id,competition_type,selected,partner_id,playerIdx){
      const postData = {
        match_id:match_id,
        competition_type:competition_type,
        selected:selected,
        partner_id:partner_id
      }
      const response = await updatePlayerParticipationInOneMatch(playerId,{data:postData})
      if (response.status === 200) {
        console.log("aft change",playerIdx,response.data.changed_participation)
        this.updateTableDataChanged(this.playerList,this.gameList,response.data.changed_participation)
        // this.$emit('reFetchLoadingRender')
        // this.tableData[playerIdx].comp[match_id] = response.data.changed_participation
        // this.$emit('controlLoading',{'loading':false})
        // message.success('update success')
      }else{
        message.error("conflict")
        //end loading
      }
      // if(this.loading)this.loading=false
      this.$store.commit('setLoading',false)
    },

    updateTableDataChanged(plist,matchlist,changedList) {
      const gameType = ['single','double','team','mixed']
      let table=this.tableData
      for(let i=0;i<changedList.length;i++){
        let player_id = changedList[i].player_id
        if(player_id.length===0)continue
        let match_id = changedList[i].match_id
        let idx_p =-1,idx_m=-1;
        for( let j=0;j<plist.length;j++) {
          if(plist[j].player_id===player_id){
            idx_p=j;
          }
        }
        for( let j=0;j<matchlist.length;j++) {
          if(matchlist[j].match_id===match_id){
            idx_m=j;
          }
        }
        if(idx_p===-1 || idx_m ===-1)continue
        let row = table[idx_p]
        row.comp[idx_m] = {
          quarter: Math.floor((matchlist[idx_m].start_date[1]-1) / 3),
          ...changedList[i]
        }
        let sum = []
        //计算这个人的数据，看看是否更新maxQ
        for(let j=0;j<4;j++) {
          let total = 0
          let type_ = gameType[j];
          let details = [0, 0, 0, 0]
          for (let k=0;k<matchlist.length;k++){
            if(row.comp[k][type_]){
              details[row.comp[k]['quarter']]+=1;
            }
            total += (row.comp[k][type_] ? 1 : 0)
          }
          sum.push({
            type: type_,
            total: total,
            details: details
          })
        }
        row.sum = sum
        table[idx_p]=row
      }
      // 直接重新计算全体球员
      let newMax = 0
      // console.log(table)
      for(let i=0;i<plist.length;i++){
        for(let j=0;j<4;j++) {
          // let type_ = gameType[j];
          if(newMax < Math.max(...(table[i].sum[j].details))){
            newMax = Math.max(...(table[i].sum[j].details))
          }

        }
      }
      debugger
      this.maxNum = newMax
      // 还是要重新计算一次，只是少了网络时间，以及更新的话只更新部分？还是所有人更新，因为有个max
      this.tableData = table;
      // console.log(table[0], this.maxNum)
      // if(this.loading)this.loading=false
      this.$store.commit('setLoading',false)
      return table;
    },

    changeMixedPartner(data) {
      // if(!this.loading)this.loading = true
      this.$store.commit('setLoading',true)
      // let cellData = this.tableData[this.mixedSelect.idx].comp[this.mixedSelect.competitionId];
      let dataType = 'mixed'
      this.mixedSelect.visible = false
      // console.log('this.mixedSelect.playerId',this.mixedSelect.playerId)
      // 设置对应的成员、比赛的混双数据，这里以this.example举例
      // cellData[`${dataType}_partner_id`] = data.mixedPartner
      // cellData[dataType] = data.mixedPartner.length > 0
      this.updatePlayerParticipation(this.mixedSelect.playerId,
          this.mixedSelect.competitionId,  dataType,
          data.mixedPartner.length > 0, data.mixedPartner,this.mixedSelect.idx
      )
    },
    changeDoublePartner(data) {
      // if(!this.loading)this.loading = true
      this.$store.commit('setLoading',true)
      let dataType = 'double'
      this.doubleSelect.visible = false
      this.updatePlayerParticipation(this.doubleSelect.playerId,
          this.doubleSelect.competitionId,  dataType,
          data.mixedPartner.length>0, data.mixedPartner,this.doubleSelect.idx
      )
    },
    getDateName(start,end){
      return `${start[1]}.${start[2]}-${end[1]}.${end[2]}`
      // return `${start[0]}.${start[1]}.${start[2]}-${end[0]}.${end[1]}.${end[2]}`
    }
  },

});
</script>

<style lang="less" scoped>
.tableHolder{
  padding-top: 2vh;
  margin-left: 30px;
  margin-right: 30px;
}
.body{
  user-select: none
}
///deep/ .ant-table-pagination.ant-pagination{
//  background-color: #FFFFFF;
//  position: relative !important;
//  top: -20px !important;
//  z-index: 999 !important;
//}
//
///deep/ .ant-pagination-total-text{
//  height: 20px !important;
//  margin: 10px;
//}


/deep/ .ant-table-header-column{
  width: 100% !important;
}
///deep/ .ant-table-scroll{
//  overflow-y: hidden!important;
//}
///deep/ .ant-table-body{
//  overflow-y: hidden!important;
//}
/deep/ .ant-table-body-inner{
  overflow-y: hidden!important;
}

/deep/ .ant-table-body:hover{
  overflow-y: scroll!important;
}
///deep/ .ant-table-row-cell-break-word{
// padding: 0 !important;
//}

///deep/ .ant-table-body-inner::-webkit-scrollbar {
//  width: 3px;
//  //height: 0.5px;
//}
///deep/ .ant-table-body-inner::-webkit-scrollbar-thumb {
//  border-radius: 10px;
//  background: rgba(0,0,0,1);
//}

///deep/ .ant-table-hide-scrollbar::-webkit-scrollbar {
//
//}



/deep/ .ant-table-body::-webkit-scrollbar {
  width: 3px;
  height: 10px;
}
/deep/ .ant-table-body::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0,0,0,0.4);
}
/deep/ .ant-table-body::-webkit-scrollbar-track {
  border-radius: 0;
  background: rgba(0,0,0,0.2);
}
</style>
